import PropTypes from "prop-types";
import React, { useState } from "react"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
  Button,
  InputGroupText, InputGroup
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo_wevalo.png";
import { handleApiError, post } from "../../helpers/api_helper"
import OTPInput from "react-otp-input"

const ForgetPasswordPage = props => {

  const [otp, setOtp] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Saisissez votre email"),
    }),
    onSubmit: (values) => {
      if (!showOtpInput) {
        handleResetPassword(values);
      } else {
        handleChangePassword(values);
      }
    }
  });


  const ForgotPasswordProperties = createSelector(
    (state) => state.ForgetPassword,
    (forgetPassword) => ({
      forgetError: forgetPassword.forgetError,
      forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
    })
  );

  const {
    forgetError,
    forgetSuccessMsg
  } = useSelector(ForgotPasswordProperties);

  const handleResetPassword = async (values) => {
    try {
      setEmail(values.email);
      const response = await post('reset-password/', values);
      if (204 === response.status) {
        setShowOtpInput(true);
      }
    } catch (error) {
      handleApiError(error.response.data);
    }
  }

  const handleChangePassword = async (values) => {
    try {
      const response = await post('/reset-password/' + otp, {
        'password': values.password
      });

      if (204 === response.status) {
        setShowForm(false);
      }
    } catch (error) {
      handleApiError(error.response.data);
    }
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h3 className="text-primary">
                          Réinitialisez votre mot de passe
                        </h3>
                        <p className="text-secondary">
                          Entrez votre adresse email ci-dessous, vous recevrez
                          un code pour réinitialiser votre mot de passe.
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="85"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  {showForm && (
                    <div className="p-2">
                      {forgetError && forgetError ? (
                        <Alert color="danger" style={{ marginTop: "13px" }}>
                          {forgetError}
                        </Alert>
                      ) : null}
                      {forgetSuccessMsg ? (
                        <Alert color="success" style={{ marginTop: "13px" }}>
                          {forgetSuccessMsg}
                        </Alert>
                      ) : null}

                      {showOtpInput && (
                        <div className="text-center mb-4">
                          <h5>
                            <strong>Consultez vos emails</strong>
                          </h5>
                          <p>
                            Nous avons envoyé un email à{" "}
                            <strong>{email}</strong> vérifier également votre
                            dossier Spam.
                            <br />
                            Vous ne l'avez pas reçu ?{" "}
                            <a
                              href="mailto:contact@wevalo.com"
                              className="text-primary text-decoration-underline"
                            >
                              Contactez-nous
                            </a>{" "}
                            pour obtenir de l'aide.
                          </p>
                        </div>
                      )}
                      <Form
                        className="form-horizontal"
                        onSubmit={e => {
                          e.preventDefault()
                          validation.handleSubmit()
                          return false
                        }}
                      >
                        <div className="mb-3">
                          <Label className="form-label">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            autoComplete={false}
                            value={email || validation.values.email || ""}
                            invalid={
                              !!(validation.touched.email &&
                                validation.errors.email)
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                          {showOtpInput && (
                            <>
                              <div className="mt-3">
                                <Label className="form-label">
                                  Nouveau mot de passe
                                </Label>
                                <InputGroup>
                                  <Input
                                    name="password"
                                    value={validation.values.password || ""}
                                    type={showPassword ? "text" : "password"} // Affiche/Masque le mot de passe
                                    placeholder="Entrez votre mot de passe"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                      validation.touched.password &&
                                      validation.errors.password
                                    }
                                  />
                                  <InputGroupText
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {showPassword ? (
                                      <i className="bx bx-hide font-size-18" />
                                    ) : (
                                      <i className="bx bx-show font-size-18" />
                                    )}
                                  </InputGroupText>
                                </InputGroup>
                              </div>
                              <div className="mt-3">
                                <Label className="form-label">
                                  Code de vérification
                                </Label>
                                <OTPInput
                                  value={otp}
                                  onChange={value => {
                                    const numericOnly = value.replace(/\D/g, "")
                                    setOtp(numericOnly)
                                  }}
                                  numInputs={6}
                                  renderSeparator={
                                    <span style={{ margin: "0 7px" }}></span>
                                  }
                                  renderInput={props => (
                                    <input
                                      type="number"
                                      inputMode="numeric"
                                      pattern="[0-9]*"
                                      {...props}
                                      style={{
                                        width: "55px",
                                        height: "50px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        textAlign: "center",
                                        fontSize: "20px",
                                        outline: "none",
                                        boxShadow: "none",
                                      }}
                                    />
                                  )}
                                />
                              </div>
                              <div className="mt-3 d-flex justify-content-end">
                                <Link
                                  to={"#"}
                                  className="text-success fw-medium"
                                  onClick={() => handleResetPassword({ email })}
                                >
                                  Renvoyer le code de vérification
                                </Link>
                              </div>
                            </>
                          )}
                        </div>
                        <Row className="mb-3">
                          <Col className="text-end">
                            <Button
                              color="primary"
                              className="w-75 d-flex align-items-center justify-content-center rounded-5 mx-auto text-uppercase"
                              type="submit"
                            >
                              {loading
                                ? "Envoi..."
                                : "Réinitialiser le mot de passe"}
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  )}
                  <p className="text-center">
                    <Link
                      to="/login"
                      className="fw-medium text-primary text-uppercase font-size-14"
                    >
                      Revenir à la page de connexion
                    </Link>{" "}
                  </p>
                </CardBody>
              </Card>
              <div className="mt-3 text-center">
                <p>© {new Date().getFullYear()} Wevalo</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
